import type { CityConfig } from "../city-template/types";

export const roanokeVaConfig: CityConfig = {
  city: "Roanoke",
  state: "Virginia",
  stateAbbr: "VA",
  slug: "roanoke-va",
  route: "/cities/roanoke-va",
  title: "Emergency Passport Roanoke, VA — Expedited & Fast Passport Service | Fast Passport Center",
  metaDescription: "Emergency and expedited passport services in Roanoke, VA — as fast as 24 hours. Same-day courier processing available. A+ BBB rated, registered State Dept. courier serving Southwest Virginia, the Roanoke Valley, and the Blue Ridge region. Get your passport fast for international travel!",
  h1: "Emergency & Expedited Passport Services in Roanoke, VA",
  heroSubtitle: "Passport expired before your international trip from Roanoke Regional Airport? Need an emergency passport fast? We help Roanoke and Southwest Virginia travelers get their expedited passports as quickly as 24 hours. A+ BBB rated. No office visit required.",
  heroImageUrl: "https://readdy.ai/api/search-image?query=Downtown%20Roanoke%20Virginia%20skyline%20with%20the%20iconic%20Roanoke%20Star%20visible%20on%20Mill%20Mountain%20in%20the%20background%2C%20modern%20buildings%20alongside%20historic%20architecture%2C%20Blue%20Ridge%20Mountains%20in%20the%20distance%2C%20warm%20golden%20hour%20lighting%2C%20professional%20photography%20with%20rich%20mountain%20atmosphere%20and%20Southern%20Virginia%20charm%2C%20no%20people%20visible%2C%20scenic%20urban%20landscape%20with%20natural%20mountain%20backdrop&width=1800&height=700&seq=roanoke-va-hero-001&orientation=landscape",
  heroImageAlt: "Downtown Roanoke Virginia skyline with the Roanoke Star on Mill Mountain and Blue Ridge Mountains in the background",
  geoPosition: "37.2710;-79.9414",
  geoPlacename: "Roanoke, Virginia",
  lastModified: "2026-07-21",
  regionalAgency: {
    name: "Washington Passport Agency",
    address: "600 19th Street NW, Washington, DC 20006",
    distance: "Located in downtown Washington, DC — approximately 240 miles northeast of Roanoke via I-81 and I-66",
  },
  nearbyCitiesZips: [
    { name: "Roanoke", zips: "24001, 24002, 24003, 24004, 24005, 24006, 24007, 24008, 24009, 24010, 24011, 24012, 24013, 24014, 24015, 24016, 24017, 24018, 24019, 24020, 24022, 24023, 24024, 24025, 24026, 24027, 24028, 24029, 24030, 24031, 24032, 24033, 24034, 24035, 24036, 24037, 24038, 24040, 24042, 24043, 24044, 24045, 24048, 24050, 24054, 24055, 24059, 24060, 24061, 24062, 24063, 24064, 24065, 24066, 24067, 24068, 24070, 24072, 24073, 24077, 24078, 24079, 24083, 24084, 24085, 24086, 24087, 24088, 24089, 24090, 24091, 24092, 24095" },
    { name: "Salem", zips: "24153, 24155, 24157" },
    { name: "Vinton", zips: "24179" },
    { name: "Blacksburg", zips: "24060, 24061, 24062, 24063" },
    { name: "Christiansburg", zips: "24068, 24073" },
    { name: "Lynchburg", zips: "24501, 24502, 24503, 24504, 24505, 24506, 24515" },
    { name: "Martinsville", zips: "24112, 24113, 24114, 24115" },
    { name: "Danville", zips: "24540, 24541, 24543, 24544" },
    { name: "Radford", zips: "24141, 24142, 24143" },
    { name: "Pulaski", zips: "24301" },
    { name: "Wytheville", zips: "24382" },
    { name: "Charlottesville", zips: "22901, 22902, 22903, 22911, 22936, 22947, 22972, 22974" },
    { name: "Richmond", zips: "23218, 23219, 23220, 23221, 23222, 23223, 23224, 23225, 23226, 23227, 23228, 23229, 23230, 23231, 23233, 23234, 23235, 23236, 23237, 23238, 23242" },
    { name: "Fairfax", zips: "22030, 22031, 22032, 22033" },
    { name: "Arlington", zips: "22201, 22202, 22203, 22204, 22205, 22206, 22207, 22209, 22213, 22214, 22217" },
  ],
  benefits: [
    { icon: "ri-time-line", title: "24–48 Hour Processing", desc: "Emergency courier submission for urgent departures from the Roanoke Valley" },
    { icon: "ri-shield-check-line", title: "Registered Courier", desc: "U.S. Department of State approved passport expediting" },
    { icon: "ri-user-line", title: "Dedicated Agent", desc: "A real person assigned to your case from start to finish" },
    { icon: "ri-map-pin-2-line", title: "Southwest Virginia Hub", desc: "Serving Roanoke, Salem, Blacksburg, and all of the Blue Ridge region" },
  ],
  internalLinks: [
    { name: "Virginia state passport services", route: "/states/virginia" },
    { name: "Charlottesville VA passport services", route: "/cities/charlottesville-va" },
    { name: "Richmond VA passport services", route: "/cities/richmond-va" },
    { name: "Fairfax VA passport services", route: "/cities/fairfax-va" },
  ],
  fpcOfficeNote: "Fast Passport Center serves Roanoke remotely via secure courier. We do not have a walk-in office in Roanoke — our registered couriers hand-deliver your documents directly to U.S. Department of State processing facilities. This is how we achieve 24–48 hour turnaround for Roanoke and Southwest Virginia travelers.",
  fpcOfficeAddress: "7272 Wisconsin Ave, Bethesda, Maryland 20814",
  fpcOfficeDistance: "Serving all of Roanoke and the surrounding Southwest Virginia area including Salem, Vinton, Blacksburg, Christiansburg, Lynchburg, Martinsville, Danville, Radford, Pulaski, and Wytheville",
  serviceAreaIntro: "From the bustling downtown of the Star City to the quiet neighborhoods of Grandin and Raleigh Court, from the university communities of Blacksburg and Radford to the rolling hills of the New River Valley and the Blue Ridge Mountains — Fast Passport Center serves every corner of Roanoke and Southwest Virginia. We regularly help travelers from Salem, Vinton, Christiansburg, Martinsville, and all across the Roanoke Valley get their passports fast.",
  nearbyCitiesIntro: "We serve all Roanoke neighborhoods and the surrounding Southwest Virginia region including Salem, Vinton, Blacksburg, Christiansburg, Lynchburg, Martinsville, Danville, Radford, Pulaski, Wytheville, and Charlottesville. If you are anywhere in the Roanoke area or the broader Blue Ridge and New River Valley region, we have you covered.",
  howItWorksIntro: "Most Roanoke travelers complete everything online and ship documents overnight. No need to drive to Washington, DC or wait in line at the regional agency.",
  mistakesIntro: "Roanoke travelers often face the temptation to drive to the Washington regional passport agency. Here are the most common mistakes that cause delays.",
  testimonialsIntro: "Roanoke and Southwest Virginia travelers trust us when their departure is days away. Here is what some of them have to say.",
  faqIntro: "Have questions about expedited passports in Roanoke? Here are the most common ones we hear from Southwest Virginia travelers.",
  statePageRoute: "/states/virginia",
  statePageName: "Virginia",
  dmvWebsite: "https://www.dmv.virginia.gov",
  dmvLabel: "Virginia DMV — Official Website",
  vitalRecordsIcon: "ri-heart-pulse-line",
  vitalRecordsLinks: [
    { icon: "ri-user-smile-line", label: "Birth Certificate", desc: "Request certified birth certificates from Virginia Department of Health Vital Records. Online, mail, or in-person options available for Roanoke and Southwest Virginia residents.", url: "https://www.vdh.virginia.gov/vital-records/" },
    { icon: "ri-file-list-2-line", label: "Death Certificate", desc: "Obtain certified death certificates through Virginia Department of Health Vital Records. Required for estate, insurance, and legal matters.", url: "https://www.vdh.virginia.gov/vital-records/" },
    { icon: "ri-hearts-line", label: "Marriage Certificate", desc: "Request marriage license records from the Roanoke Circuit Court Clerk. Certified copies available for name changes and legal purposes.", url: "https://www.roanokeva.gov/" },
    { icon: "ri-file-copy-line", label: "Divorce Decree", desc: "Obtain certified divorce records through the Roanoke Circuit Court Clerk. Required for name change passport corrections.", url: "https://www.roanokeva.gov/" },
  ],
  stickyNavLinks: [
    { label: "Processing", href: "#processing-options" },
    { label: "Services", href: "#services" },
    { label: "Service Area", href: "#service-area" },
    { label: "Facilities", href: "#acceptance-facilities" },
    { label: "Comparison", href: "#comparison" },
    { label: "How It Works", href: "#how-it-works" },
    { label: "FAQ", href: "#faq" },
    { label: "Resources", href: "#local-resources" },
  ],
  processingOptions: [
    {
      speed: "2–9",
      unit: "Business Days",
      label: "Fast Passport Center",
      tag: "Most Popular",
      tagColor: "bg-[#F6C344] text-[#1A365D]",
      features: [
        "Registered U.S. Department of State Courier",
        "Reserved agency submission",
        "Predictable turnaround",
        "Ideal for upcoming trips",
        "Document review included",
        "Dedicated agent assigned to your case",
        "Daily status updates — never left guessing",
        "Not affected by government shutdowns",
      ],
      highlight: true,
    },
    {
      speed: "3–5",
      unit: "Weeks",
      label: "Fast Passport Center",
      tag: "Standard Expedited",
      tagColor: "bg-[#1A365D]/10 text-[#1A365D]",
      features: [
        "Registered U.S. Department of State Courier",
        "Reserved agency submission",
        "Faster than self-service",
        "Good for planned travel",
        "Document review included",
        "Dedicated agent assigned to your case",
        "Daily status updates — never left guessing",
        "Not affected by government shutdowns",
      ],
      highlight: false,
      smartSaver: true,
    },
    {
      speed: "1–2",
      unit: "Months",
      label: "Self-Service (Post Office)",
      tag: "Slowest",
      tagColor: "bg-gray-100 text-gray-400",
      features: [
        "No courier access — standard mail only",
        "Workload & wait times shift with shutdowns",
        "In-person clerk appointment required",
        "No document review — errors cause rejection",
        "No dedicated agent — you are on your own",
        "Updates only by physical mail letter",
        "No phone or email contact for your case",
        "Can't upgrade speed after submission",
        "Not suitable if travel is within 10 weeks",
      ],
      highlight: false,
      muted: true,
    },
    {
      speed: "24",
      unit: "Hours*",
      label: "Regional Agency Processing",
      tag: "Emergency Only",
      tagColor: "bg-gray-100 text-gray-500",
      features: [
        "Appointment required — no walk-ins allowed",
        "Life-or-death emergencies only",
        "Bereavement or medical crisis",
        "Expect to wait all day or return next day",
      ],
      highlight: false,
      emergency: true,
    },
  ],
  services: [
    {
      icon: "ri-flashlight-line",
      title: "Emergency Passport",
      description: "For travelers with immediate departure needs — as fast as 24 hours for urgent Roanoke international flights and mountain region departures.",
      bullets: ["24–48 hour turnaround available", "Registered courier hand-delivery", "Flight verification support"],
      badge: "Most Popular",
      link: "https://fastpassportcenter.com/checkout/?passport=new-passport",
    },
    {
      icon: "ri-passport-line",
      title: "Passport Renewal",
      description: "Fast renewal for adults with a passport issued within the last 15 years at age 16 or older.",
      bullets: ["No clerk visit required for most", "Mail-in or courier options", "Lost passport replacement available"],
      badge: null,
      link: "https://fastpassportcenter.com/checkout/?passport=passport-renewal",
    },
    {
      icon: "ri-add-circle-line",
      title: "New Passport",
      description: "First-time passport application guidance with acceptance clerk appointment support.",
      bullets: ["Acceptance facility locator", "Form DS-11 assistance", "Photo requirement guidance"],
      badge: null,
      link: "https://fastpassportcenter.com/checkout/?passport=new-passport",
    },
    {
      icon: "ri-alert-line",
      title: "Lost or Stolen Passport",
      description: "Passport replacement with DS-64 form guidance and police report documentation.",
      bullets: ["DS-64 form assistance", "Identity verification support", "Emergency replacement options"],
      badge: "Urgent",
      link: "https://fastpassportcenter.com/checkout/?passport=lost-stolen-passport",
    },
    {
      icon: "ri-parent-line",
      title: "Child Passport",
      description: "Passport services for minors under 16 with parental consent and acceptance clerk support.",
      bullets: ["DS-11 form for minors", "Parental consent guidance", "Both parents presence rules"],
      badge: null,
      link: "https://fastpassportcenter.com/checkout/?passport=child-passport",
    },
    {
      icon: "ri-file-edit-line",
      title: "Name Change",
      description: "Passport correction and name change service after marriage, divorce, or legal changes.",
      bullets: ["DS-5504 or DS-82 guidance", "Marriage certificate support", "Court order documentation"],
      badge: null,
      link: "https://fastpassportcenter.com/checkout/?passport=name-change",
    },
  ],
  servicesSchema: [
    { name: "Emergency Passport", description: "Urgent passport processing for travelers with immediate departure needs, as fast as 24 hours." },
    { name: "Passport Renewal", description: "Fast passport renewal for U.S. citizens with a passport issued within the last 15 years at age 16 or older." },
    { name: "New Passport", description: "First-time passport application assistance with step-by-step guidance through the acceptance clerk process." },
    { name: "Lost or Stolen Passport", description: "Passport replacement service for lost or stolen passports, including DS-64 form guidance." },
    { name: "Child Passport", description: "Passport services for minors under 16, with parental consent guidance and acceptance clerk support." },
    { name: "Name Change", description: "Passport correction and name change service after marriage, divorce, or legal name changes." },
  ],
  testimonials: [
    {
      name: "Jennifer L.",
      location: "Roanoke, VA",
      rating: 5,
      text: "I needed an emergency passport for a business trip to Frankfurt leaving from Roanoke Regional Airport. I discovered my passport was expired just 4 days before my flight. Fast Passport Center had my renewal processed in 3 days. I shipped from the UPS on Franklin Road and never missed my flight. Incredible service for Southwest Virginia!",
      service: "Passport Renewal",
    },
    {
      name: "Dr. Robert H.",
      location: "Blacksburg, VA",
      rating: 5,
      text: "As a Virginia Tech professor heading to a conference in Tokyo, I had a passport crisis with 6 days to go. Fast Passport Center delivered in 4 days. Their understanding of academic travel schedules and the remote location of Southwest Virginia was a huge relief. I recommend them to every colleague at VT.",
      service: "Emergency Passport",
    },
    {
      name: "Amanda S.",
      location: "Salem, VA",
      rating: 5,
      text: "First passports for my two kids before our family trip to the Dominican Republic. Fast Passport Center handled the parental consent requirements and had both passports in 6 days. The convenience for Salem residents was incredible — we shipped from the UPS on Main Street and it was seamless.",
      service: "Child Passport",
    },
    {
      name: "David K.",
      location: "Vinton, VA",
      rating: 5,
      text: "Lost my passport 72 hours before a cruise out of Norfolk. I was absolutely panicking because I live in Vinton and thought I would have to drive to DC. Fast Passport Center had a replacement in my hands in 48 hours. They saved our family vacation that we had been planning for over a year. Southwest Virginia service is top notch.",
      service: "Lost Passport",
    },
  ],
  facilities: [
    {
      id: "roanoke-va-1",
      name: "Roanoke Main Post Office",
      type: "USPS Passport Acceptance Facility",
      address: "419 Rutherford Ave NE",
      city: "Roanoke",
      state: "VA",
      zip: "24023",
      phone: "(540) 982-7222",
      hours: "Mon–Fri: 9:00 AM – 4:00 PM",
      distance: "Downtown Roanoke",
      website: "https://tools.usps.com/find-location.htm",
      websiteLabel: "USPS Location Finder",
      notes: "Primary Roanoke facility. Full passport services with appointment. Call ahead to confirm.",
      icon: "ri-mail-line",
    },
    {
      id: "roanoke-va-2",
      name: "Salem Post Office",
      type: "USPS Passport Acceptance Facility",
      address: "320 E Main St",
      city: "Salem",
      state: "VA",
      zip: "24153",
      phone: "(540) 387-0191",
      hours: "Mon–Fri: 9:00 AM – 4:00 PM",
      distance: "Salem, adjacent to Roanoke",
      website: "https://tools.usps.com/find-location.htm",
      websiteLabel: "USPS Location Finder",
      notes: "Serves Salem and western Roanoke County. Full passport services with appointment.",
      icon: "ri-mail-line",
    },
    {
      id: "roanoke-va-3",
      name: "Vinton Post Office",
      type: "USPS Passport Acceptance Facility",
      address: "105 E Jackson Ave",
      city: "Vinton",
      state: "VA",
      zip: "24179",
      phone: "(540) 343-1571",
      hours: "Mon–Fri: 9:00 AM – 4:00 PM",
      distance: "Vinton, east of Roanoke",
      website: "https://tools.usps.com/find-location.htm",
      websiteLabel: "USPS Location Finder",
      notes: "Serves Vinton and eastern Roanoke County. Full passport services with appointment.",
      icon: "ri-mail-line",
    },
    {
      id: "roanoke-va-4",
      name: "Christiansburg Post Office",
      type: "USPS Passport Acceptance Facility",
      address: "1500 Roanoke St",
      city: "Christiansburg",
      state: "VA",
      zip: "24073",
      phone: "(540) 382-6221",
      hours: "Mon–Fri: 9:00 AM – 4:00 PM",
      distance: "Christiansburg, south of Roanoke near Blacksburg",
      website: "https://tools.usps.com/find-location.htm",
      websiteLabel: "USPS Location Finder",
      notes: "Serves Christiansburg, Blacksburg, and the New River Valley. Full passport services with appointment.",
      icon: "ri-mail-line",
    },
    {
      id: "roanoke-va-5",
      name: "Lynchburg Post Office",
      type: "USPS Passport Acceptance Facility",
      address: "3300 Odd Fellows Rd",
      city: "Lynchburg",
      state: "VA",
      zip: "24501",
      phone: "(434) 237-2651",
      hours: "Mon–Fri: 9:00 AM – 4:00 PM",
      distance: "Lynchburg, east of Roanoke",
      website: "https://tools.usps.com/find-location.htm",
      websiteLabel: "USPS Location Finder",
      notes: "Serves Lynchburg and eastern Southwest Virginia. Full passport services with appointment.",
      icon: "ri-mail-line",
    },
    {
      id: "roanoke-va-6",
      name: "Martinsville Post Office",
      type: "USPS Passport Acceptance Facility",
      address: "1123 E Church St",
      city: "Martinsville",
      state: "VA",
      zip: "24112",
      phone: "(276) 632-8121",
      hours: "Mon–Fri: 9:00 AM – 4:00 PM",
      distance: "Martinsville, south of Roanoke near the NC border",
      website: "https://tools.usps.com/find-location.htm",
      websiteLabel: "USPS Location Finder",
      notes: "Serves Martinsville and Henry County. Full passport services with appointment.",
      icon: "ri-mail-line",
    },
  ],
  comparisonRows: [
    { feature: "Appointment Needed", agency: "Yes — call NPIC, limited slots", fpc: "No — we handle everything for you" },
    { feature: "Processing Speed", agency: "Same-day if approved (rare)", fpc: "24–48 hours guaranteed for emergency" },
    { feature: "Document Review", agency: "No — rejected if wrong", fpc: "Yes — we check before submission" },
    { feature: "Travel to Agency", agency: "Yes — drive into downtown DC", fpc: "No — ship from home or office" },
    { feature: "Agent Support", agency: "No — government clerk only", fpc: "Yes — dedicated agent assigned" },
    { feature: "Status Updates", agency: "No — no tracking provided", fpc: "Yes — daily email updates" },
    { feature: "Guaranteed Timing", agency: "No — subject to availability", fpc: "Yes — contractual turnaround times" },
    { feature: "Military & Government", agency: "No special handling", fpc: "Yes — priority for military and government travelers" },
    { feature: "Multi-Application Households", agency: "One slot per application", fpc: "Yes — family batch processing supported" },
  ],
  mistakes: [
    {
      icon: "ri-image-line",
      title: "Wrong Photo Size or Background",
      description: "Roanoke photo shops often use generic sizes. Passport photos must be exactly 2×2 inches with a white or off-white background.",
    },
    {
      icon: "ri-file-list-line",
      title: "Incomplete DS-11 Form",
      description: "Missing signatures or using the wrong form type are the #1 reasons for rejection at Southwest Virginia acceptance facilities.",
    },
    {
      icon: "ri-money-dollar-circle-line",
      title: "Wrong Payment Amount",
      description: "Fees change frequently. Many Roanoke applicants show up with incorrect payment and have to reschedule their appointment.",
    },
    {
      icon: "ri-calendar-close-line",
      title: "No Proof of Travel",
      description: "Without flight confirmation or travel itinerary, the Washington DC regional agency will turn you away for emergency appointments.",
    },
    {
      icon: "ri-parent-line",
      title: "Missing Parental Consent",
      description: "For minors, both parents must appear or submit notarized consent. This trips up many Roanoke families at the clerk.",
    },
    {
      icon: "ri-time-line",
      title: "Waiting Too Long to Start",
      description: "Roanoke travelers often assume standard processing will be fine. It takes 8–11 weeks. Start expedited at least 3 weeks before travel.",
    },
  ],
  steps: [
    { number: "1", icon: "ri-file-list-line", title: "Apply Online", description: "Complete your application on our secure website in under 10 minutes." },
    { number: "2", icon: "ri-mail-send-line", title: "Ship Documents", description: "We send you a prepaid overnight label. Drop your documents at any UPS location in Roanoke or nearby." },
    { number: "3", icon: "ri-shield-check-line", title: "We Review", description: "Our team checks every document for accuracy before hand-delivering to the State Department." },
    { number: "4", icon: "ri-passport-line", title: "Processing", description: "Your passport is processed at a U.S. Department of State facility using our registered courier slots." },
    { number: "5", icon: "ri-truck-line", title: "Delivery", description: "We overnight your new passport back to your Roanoke address — trackable every step of the way." },
  ],
  faqs: [
    { q: "Can I get an emergency passport in Roanoke before my international trip?", a: "Yes. Fast Passport Center provides emergency passport services in Roanoke for travelers with urgent international departures. Our registered couriers hand-deliver your documents directly to U.S. Department of State facilities, achieving 24–48 hour turnaround — without the long drive to Washington, DC." },
    { q: "How fast can I renew my passport in Roanoke?", a: "Fast Passport Center offers fast passport renewal in Roanoke in as little as 24–48 hours through our emergency courier service. For less urgent travel, our 3–5 day expedited option provides the best value. Both options include full document review and a dedicated agent." },
    { q: "What is the closest passport agency to Roanoke?", a: "The nearest regional passport agency to Roanoke is the Washington Passport Agency, located approximately 240 miles away in downtown Washington, DC. For urgent processing without navigating the long drive through the Blue Ridge Mountains and DC traffic, Fast Passport Center's registered courier service achieves 24–48 hour turnaround from Roanoke without any in-person agency visit required." },
    { q: "Can I get a same-day passport appointment near Roanoke?", a: "Same-day passport appointments are only available at the Washington Regional Passport Agency for documented life-or-death emergencies. For all other urgent travel, Fast Passport Center's 24–48 hour emergency courier processing is the fastest guaranteed option for Roanoke residents." },
    { q: "Can I expedite a child passport in Roanoke?", a: "Yes. Fast Passport Center expedites child passports in Roanoke for minors under 16. Both parents must appear or submit notarized consent, along with the child's birth certificate and both parents' IDs. We walk Roanoke families through the entire process." },
    { q: "What should I do if I lost my passport before a trip?", a: "If you lost your passport before a trip, contact Fast Passport Center immediately. We provide lost passport replacement services in Roanoke with DS-64 form guidance and identity verification support. Our emergency courier service can get your replacement passport in 24–48 hours." },
    { q: "How fast can I get a passport in Roanoke?", a: "With Fast Passport Center's emergency courier service, Roanoke travelers can receive their passport in as little as 24–48 hours. Our registered couriers hand-deliver your documents directly to U.S. Department of State processing facilities, bypassing standard mail delays." },
    { q: "Do I need to drive to the Washington Passport Agency?", a: "No. With Fast Passport Center, you complete everything online and ship your documents overnight. Our couriers handle the in-person delivery to State Department facilities. You only need to visit a local acceptance clerk if you're a first-time applicant or need a name change." },
    { q: "Where are the closest passport acceptance facilities near Roanoke?", a: "Popular options include the Roanoke Main Post Office (24023), Salem Post Office (24153), Vinton Post Office (24179), Christiansburg Post Office (24073), Lynchburg Post Office (24501), and Martinsville Post Office (24112). All require appointments. We help you find the most convenient location and schedule your visit." },
    { q: "Can I get a same-day passport in Roanoke?", a: "Same-day passports are only available at the Washington Regional Passport Agency for documented life-or-death emergencies with proof of travel within 72 hours. For all other urgent travel, Fast Passport Center's 24–48 hour emergency processing is the fastest reliable option — without the DC drive through the Blue Ridge Mountains." },
    { q: "What if I live in a smaller Southwest Virginia town?", a: "We serve the entire Southwest Virginia region including Salem, Vinton, Blacksburg, Christiansburg, Lynchburg, Martinsville, Danville, Radford, Pulaski, and Wytheville. Our overnight shipping labels work from any UPS location, so your location doesn't affect processing speed." },
    { q: "How much does expedited passport service cost in Roanoke?", a: "Government fees are fixed: $130 for a passport book (adult) plus a $60 expedite fee. Fast Passport Center's service fees vary by processing speed — emergency 24–48 hour processing, 3–5 day expedited, or standard options. Contact us for a personalized quote based on your timeline." },
    { q: "Do you help with passport photos in Roanoke?", a: "We guide you on exact photo requirements and can recommend locations near you. Many CVS, Walgreens, and FedEx Office locations in Roanoke, Salem, and Blacksburg offer passport photo services. We review your photos before submission to ensure they meet State Department standards." },
    { q: "What documents do I need for a first-time passport in Roanoke?", a: "You'll need proof of citizenship (birth certificate or naturalization certificate), government-issued photo ID (driver's license or REAL ID), two passport photos, and payment. We provide a complete checklist and review your documents before you visit the acceptance clerk." },
    { q: "Can you help with a child's passport in Roanoke?", a: "Yes. Child passports require both parents (or notarized consent from the absent parent), the child's birth certificate, and both parents' IDs. We walk Roanoke families through the entire process and help schedule acceptance clerk appointments." },
  ],
  photoLocations: [
    { name: "CVS Pharmacy — Roanoke", address: "2401 Franklin Rd SW, Roanoke, VA 24014", hours: "Mon–Sun: 8AM–10PM" },
    { name: "Walgreens — Roanoke", address: "1809 Franklin Rd SW, Roanoke, VA 24014", hours: "Mon–Sun: 7AM–11PM" },
    { name: "FedEx Office — Roanoke", address: "4480 Electric Rd, Roanoke, VA 24018", hours: "Mon–Fri: 7AM–9PM, Sat: 8AM–6PM" },
    { name: "CVS Pharmacy — Salem", address: "1415 W Main St, Salem, VA 24153", hours: "Mon–Sun: 8AM–10PM" },
    { name: "Walgreens — Blacksburg", address: "912 University City Blvd, Blacksburg, VA 24060", hours: "Mon–Sun: 7AM–11PM" },
    { name: "CVS Pharmacy — Christiansburg", address: "1955 Roanoke St, Christiansburg, VA 24073", hours: "Mon–Sun: 8AM–10PM" },
    { name: "Walgreens — Lynchburg", address: "2415 Wards Rd, Lynchburg, VA 24502", hours: "Mon–Sun: 7AM–11PM" },
    { name: "FedEx Office — Lynchburg", address: "4025 Wards Rd, Lynchburg, VA 24502", hours: "Mon–Fri: 7AM–9PM, Sat: 8AM–6PM" },
  ],
  dmvLocations: [
    {
      name: "Virginia DMV — Roanoke",
      address: "3315 Peters Creek Rd NW, Roanoke, VA 24019",
      hours: "Mon–Fri: 8AM–5PM",
      note: "Driver's license and REAL ID services. Appointment recommended.",
      featured: true,
    },
    {
      name: "Virginia DMV — Salem",
      address: "1004 E Main St, Salem, VA 24153",
      hours: "Mon–Fri: 8AM–5PM",
      note: "REAL ID and passport-related ID services. Appointment strongly recommended.",
      featured: false,
    },
    {
      name: "Virginia DMV — Blacksburg",
      address: "3710 Brambleton Ave, Christiansburg, VA 24073",
      hours: "Mon–Fri: 8AM–5PM",
      note: "Serves Blacksburg and Virginia Tech area. REAL ID available.",
      featured: false,
    },
    {
      name: "Virginia DMV — Lynchburg",
      address: "3025 Wards Rd, Lynchburg, VA 24502",
      hours: "Mon–Fri: 8AM–5PM",
      note: "Serves Lynchburg and eastern Southwest Virginia. REAL ID available.",
      featured: true,
    },
  ],
  airports: [
    {
      code: "ROA",
      name: "Roanoke-Blacksburg Regional Airport",
      distance: "5 miles north of downtown Roanoke",
      address: "5202 Aviation Dr NW, Roanoke, VA 24012",
      note: "The primary airport for Roanoke and Southwest Virginia. Direct flights to major hubs including Atlanta, Charlotte, Chicago, and New York — perfect for connecting to international destinations. Accessible via I-581 and Hershberger Road.",
      flightUrl: "https://www.flyroa.com/",
      flightLabel: "ROA Airport",
      featured: true,
    },
    {
      code: "DCA",
      name: "Ronald Reagan Washington National Airport",
      distance: "240 miles northeast of Roanoke",
      address: "2401 Smith Ave, Arlington, VA 22202",
      note: "Major international hub for long-haul flights. Accessible via I-81 and I-66.",
      flightUrl: "https://www.flyreagan.com/",
      flightLabel: "DCA Airport",
      featured: false,
    },
    {
      code: "IAD",
      name: "Dulles International Airport",
      distance: "250 miles northeast of Roanoke",
      address: "1 Saarinen Cir, Dulles, VA 20166",
      note: "Major international hub for long-haul flights to Europe, Asia, and beyond. Accessible via I-81 and I-66.",
      flightUrl: "https://www.flydulles.com/",
      flightLabel: "IAD Airport",
      featured: false,
    },
    {
      code: "RIC",
      name: "Richmond International Airport",
      distance: "190 miles east of Roanoke",
      address: "1 Richard E Byrd Terminal Dr, Richmond, VA 23250",
      note: "Alternative regional hub for domestic flights. Accessible via I-64.",
      flightUrl: "https://www.flyrichmond.com/",
      flightLabel: "RIC Airport",
      featured: false,
    },
    {
      code: "CHO",
      name: "Charlottesville-Albemarle Airport",
      distance: "120 miles northeast of Roanoke",
      address: "1000 Bowen Loop, Charlottesville, VA 22911",
      note: "Regional hub for domestic flights. Accessible via I-81 and I-64.",
      flightUrl: "https://www.gocho.com/",
      flightLabel: "CHO Airport",
      featured: false,
    },
  ],
};